// @flow

import React from 'react';
import { colors } from '../constants';

type Props = {
  size: string,
};

function CircleXIcon({ size = '20' }: Props) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 20c5.524 0 10-4.476 10-10 0-5.521-4.478-10-10-10S0 4.479 0 10c0 5.524 4.476 10 10 10zm0-18.919A8.92 8.92 0 0118.919 10 8.917 8.917 0 0110 18.919 8.917 8.917 0 011.081 10 8.92 8.92 0 0110 1.081z"
        fill={colors.darkRed}
      />
      <path
        d="M7.521 13.243l5.723-5.722a.54.54 0 10-.764-.764l-5.723 5.722a.54.54 0 10.764.764z"
        fill={colors.darkRed}
      />
      <path
        d="M13.244 12.479L7.521 6.757a.54.54 0 10-.764.764l5.723 5.722a.54.54 0 00.764-.764z"
        fill={colors.darkRed}
      />
    </svg>
  );
}

export default CircleXIcon;
